import React from 'react';
import './PlanDemo.scss';

const PlanDemo = () => (
    <div className='plan-demo' role='group' aria-label='Пример, не ваши показатели: 1 200 рублей из цели 3 000 рублей, выполнено 40 процентов'>
        <div className='plan-demo-heading'>
            <span className='plan-demo-badge'>Пример</span>
            <span>Как выглядит план</span>
            <strong className='plan-demo-percent'>40%</strong>
        </div>
        <div className='plan-demo-revenue'>1 200 ₽ <small>выручка</small></div>
        <div className='plan-demo-track' aria-hidden='true'>
            <div className='plan-demo-fill'/>
        </div>
        <div className='plan-demo-footer'>
            <span>Цель 3 000 ₽</span>
            <span>Осталось 1 800 ₽</span>
        </div>
    </div>
);

export default PlanDemo;
